import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const SortDesc = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.8542 7.65625L12.3542 5.15625C12.2708 5.05208 12.1563 5 12.0104 5C11.8646 5 11.75 5.05208 11.6667 5.15625L9.16667 7.65625C9 7.80208 8.95833 7.97917 9.04167 8.1875C9.125 8.39583 9.28125 8.5 9.51042 8.5H11.0104V18.5C11.0104 18.6458 11.0573 18.7656 11.151 18.8594C11.2448 18.9531 11.3646 19 11.5104 19H12.5104C12.6563 19 12.776 18.9531 12.8698 18.8594C12.9635 18.7656 13.0104 18.6458 13.0104 18.5V8.5H14.5104C14.7396 8.5 14.8958 8.39583 14.9792 8.1875C15.0625 7.97917 15.0208 7.80208 14.8542 7.65625Z"
            fill={color}
        />
    </StarryUIIcon>
);
